import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AuthenticationProvider } from "./shared/context/AuthenticationContext";
import { ConstantProvider } from "./shared/context/ConstantContext";
import { UserProvider } from "./shared/context/UserContext";
import setAxiosDefaults from "./utils/setAxiosDefaults";
// import "./css/main.css";


// const GlobalStyles = createGlobalStyle`
// // *{
// //   font-family: calibri;
// // }
//   @font-face {
//     font-family: pf_handbook_promedium;
//     src: url('./public/fonts/pfhandbookpro-medium.woff2') format('woff2'),
//           url('./public/fonts/pfhandbookpro-medium.woff') format('woff');
//     font-weight: normal;
//     font-style: normal;
//   }
//   @font-face {
//     font-family: 'pf_handbook_proregular';
//     src: url('./public/fonts/pfhandbookpro-regular.woff2') format('woff2'),
//       url('./public/fonts/pfhandbookpro-regular.woff') format('woff');
//     font-weight: normal;
//     font-style: normal;
//   }

//   html {
//     font-size: 10px;
//     height: 100%;
//     overflow-x: hidden;
//   }
  
//   body {
//     min-height:100%;
//     display: flex;
//     flex-direction: column;
//     font-family: 'pf_handbook_promedium', sans-serif;
//     overflow-x: hidden;
//   }
  
//   #root {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
    
//     /* colors */
//     --color-lightRoyalBlue: #f7a500;
//     --color-lightBlueGrey: #cdcece;
//     --color-lightSkyBlue: #f1f3f6;
//     --color-paleGrey: #f2f3f6;
//     --color-battleshipGrey: #6c7174;
//     --color-dirtBrownTwo: #695930;
//     --color-greyishBrown: #695940;
//     --color-beige: #e1c899;
//     --color-dirtBrown: #695934;
//     --color-tanTwo: #d4ae69;
//     --color-desert: #d4ae59;
//     --color-lipstickTwo: #c7222a;
//     --color-blackShade: #281c1c;
    
//     --color-white: rgb(255,255,255);
//     --color-black: rgb(0,0,0);
//     --color-tan_two: rgb(212, 174, 105);
//     --color-pale_grey: rgb(242, 243, 246);
//     --color-light_blue_grey: rgb(205, 206, 206);
//     --color-error_red: rgb(200, 34, 42);
//     --color-error_red_light: rgb(246,219,221);
//     --color-dirt_brown: rgb(105, 89, 52);
//     --color-dirt_brown_dark: rgb(82, 70, 40);
//     --color-battleship_grey: rgb(108, 113, 116);
//     --color-lipstick: rgb(224, 198, 150);
//     --color-tan: rgb(236, 221, 192);
//     --color-tan_light: rgb(247, 240, 225);
//     --color-pine: rgb(62, 89, 60);
//     --color-desert:rgb(212, 174, 89);
//     --color-brick:rgb(189,43,43);
//     --color-input-bg: #FCFCFC;
//     --color-input-border: rgba(232, 232, 232, 1);
    
//     --color-paleteal: #695934;
//     --color-mango: #000000;
//     --color-footergray: rgb(108, 113, 116);
//     --color-disabledgray: rgb(242, 243, 246);
//     --color-borderedbutton: rgb(105, 89, 48);


//     /* font sizes */
//     --font-size-1: 16pt;
//     --font-size-2: 18pt;

//     /* spacing */
//     --spacing-xs: 4pt;
//     --spacing-s: 8pt;
//     --spacing-m: 12pt;
//   }
//   *,
//   *::after,
//   *::before,
//   *::placeholder {
//     box-sizing: border-box;
//     margin: 0;
//     padding: 0;
//     font-family: inherit;
//     -webkit-appearance: none;
//     -moz-appearance: none;
//     appearance: none;
//   }  

//   ::-webkit-scrollbar {
//     /* width */
//     width: 1rem;
//   }
//   ::-webkit-scrollbar-track {
//     /* Track */
//     background: white;
//   }
//   ::-webkit-scrollbar-thumb {
//     /* Handle */
//     background: rgba(212, 174, 105, 0.8);
//     border-radius: 2.5rem;
//     border: 2px solid transparent;
//     background-clip: padding-box;
//   }
//   ::-webkit-scrollbar-thumb:hover {
//     /* Handle on hover */
//     cursor: pointer;
//     background: rgba(212, 174, 105, 1);
//     border-radius: 2.5rem;
//     border: 2px solid transparent;
//     background-clip: padding-box;
//   }
  
// `
//   ;

setAxiosDefaults();

ReactDOM.render(
  <>
    <React.StrictMode>
      {/* <GlobalStyles /> */}
      <ConstantProvider>
        <AuthenticationProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </AuthenticationProvider>
      </ConstantProvider>
    </React.StrictMode>
  </>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
